/*eslint-disable no-undef*/
import React, { Component } from 'react';

class Page1 extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    window.deeploop.page("Page 1");
  }

  render() {
    return (
      <div>
          This is page #1
      </div>
    )
  }
}

export default Page1;


// WEBPACK FOOTER //
// ./src/components/Page1.jsx